import React, { useEffect, useState } from "react";
import { Divider } from "antd";
import useUser from "../../Hooks/useUser";
import { useNavigate } from "react-router-dom";
import PricingPageHeader from "./components/PricingPageHeader";
import PlanFeatureTable from "./components/PlanFeatureTable";
import PlanModeSelector from "./components/PlanModeSelector";
import { useLoader } from "../../Context/LoaderContext";
import useAccess from "../../Hooks/useAccess";
import subscriptionService from "../../Service/subscription.service";
import { Subscription } from "../../Entities/Subscription";
import "./index.scss";

const Pricing: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { setLoading, setLoadingMessage } = useLoader();
  const { currentSubscription, currentPlan, currentMode } = useAccess();
  const [paidSubscriptions, setPaidSubscriptions] = useState<Subscription[]>(
    []
  );

  useEffect(() => {
    if (user && user.role !== "admin") {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (currentSubscription && currentPlan) {
      setLoading(false);
      setLoadingMessage(null);
    } else {
      setLoading(true);
      setLoadingMessage("Loading subscription data...");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPlan, currentSubscription]);

  useEffect(() => {
    if (currentPlan && currentSubscription) {
      subscriptionService
        .getSubscriptionByStatus("paid")
        .then((response) => {
          setPaidSubscriptions(Array.isArray(response) ? response : []);
        })
        .catch(() => setPaidSubscriptions([]));
    }
  }, [currentPlan, currentSubscription]);

  const hasUpcomingSubscription = paidSubscriptions.length > 0;

  return (
    <section className="dashboard-page pricing-page hide-scroll-bar">
      <PricingPageHeader />
      <Divider style={{ margin: 0 }} />
      {currentPlan && currentSubscription && currentMode && (
        <PlanModeSelector
          currentMode={currentMode}
          currentPlan={currentPlan}
          currentSubscription={currentSubscription}
          hasUpcomingSubscription={hasUpcomingSubscription}
          paidSubscriptions={paidSubscriptions}
        />
      )}
      <Divider style={{ margin: 0 }} />
      <PlanFeatureTable />
    </section>
  );
};

export default Pricing;
